<div class="p-2 light-blue-header d-flex flex-row justify-content-between modal-header">
    <div class="p-2 modal-title"><h5>Rxdb Buildings</h5></div>
    <button class="p-0 m-0 btn" style="line-height: .8; color: white" (click)="onCancel()" aria-label="Close">
        <i class="fa fa-window-close"></i>
    </button>
</div>

<div class="container-fluid busy-overlay-parent p-2" [ngClass]="bProcessing?'disabled':''">
    <div *ngIf="bProcessing" class="font-weight-bold busy-overlay">
        <i class="fa fa-spinner fa-spin"></i>&nbsp;Processing...
    </div>
    <form #buildingForm="ngForm">
        <table class="edit-table table table-striped table-condensed">
            <thead>
            </thead>
            <tbody>
                <tr *ngIf="tmpBuilding?.id">
                    <th>ID</th>
                    <td>{{tmpBuilding?.id}}</td>
                </tr>
                <tr>
                    <th>Market</th>
                    <td>
                        <select name="market" type='text' class="form-control w-100"
                        [(ngModel)]="tmpBuilding.market" #market="ngModel" required market
                        [ngClass]="{ 'invalid-input': market.invalid && (market.dirty || market.touched)}"
                        >
                            <option value="">{{tmpBuilding.market}}</option>
                            <option *ngFor="let rxMarket of rxMarkets">{{rxMarket.name}}</option>
                        </select>
                    </td>
                </tr>
                <tr>
                    <th>Morphology</th>
                    <td>
                        <input size=70 name="morphology" type='text' class="form-control w-100"
                            [(ngModel)]="tmpBuilding.morphology" #morphology="ngModel" required
                            [ngClass]="{ 'invalid-input': morphology.invalid && (morphology.dirty || morphology.touched)}" >
                    </td>
                </tr>
                <tr>
                    <th>Use Category</th>
                    <td>
                        <input size=70 name="useCategory" type='text' class="form-control w-100"
                            [(ngModel)]="tmpBuilding.useCategory" #useCategory="ngModel"
                            [ngClass]="{ 'invalid-input': useCategory.invalid && (useCategory.dirty || useCategory.touched)}" >
                    </td>
                </tr>
                <tr>
                    <th>Category</th>
                    <td>
                        <input size=70 name="category" type='text' class="form-control w-100"
                            [(ngModel)]="tmpBuilding.category" #category="ngModel"
                            [ngClass]="{ 'invalid-input': category.invalid && (category.dirty || category.touched)}" >
                    </td>
                </tr>
                <tr>
                    <th>Characteristics</th>
                    <td>
                        <input size=70 id="characteristics" name="characteristics" type='text' class="form-control w-100"
                            [(ngModel)]="tmpBuilding.characteristics" #characteristics="ngModel"
                            [ngClass]="{ 'invalid-input': characteristics.invalid && (characteristics.dirty || characteristics.touched)}" >
                    </td>
                </tr>
                <tr>
                    <th>Common Name</th>
                    <td>
                        <input size=70 id="commonName" name="commonName" type='text' class="form-control w-100"
                            [(ngModel)]="tmpBuilding.commonName" #commonName="ngModel"
                            [ngClass]="{ 'invalid-input': commonName.invalid && (commonName.dirty || commonName.touched)}" >
                    </td>
                </tr>
                <tr>
                    <th>Civic Address</th>
                    <td>
                        <input size=70 id="civicAddress" name="civicAddress" type='text' class="form-control w-100"
                            [(ngModel)]="tmpBuilding.civicAddress" #civicAddress="ngModel"
                            [ngClass]="{ 'invalid-input': civicAddress.invalid && (civicAddress.dirty || civicAddress.touched)}" >
                    </td>
                </tr>
                <tr>
                    <th>Civic Latitude</th>
                    <td>
                        <input size=70 id="civicLatitude" name="civicLatitude" type='text' class="form-control w-100"
                            [(ngModel)]="tmpBuilding.civicLatitude" #civicLatitude="ngModel"
                            [ngClass]="{ 'invalid-input': civicLatitude.invalid && (civicLatitude.dirty || civicLatitude.touched)}" >
                    </td>
                </tr>
                <tr>
                    <th>Civic Longitude</th>
                    <td>
                        <input size=70 id="civicLongitude" name="civicLongitude" type='text' class="form-control w-100"
                            [(ngModel)]="tmpBuilding.civicLongitude" #civicLongitude="ngModel"
                            [ngClass]="{ 'invalid-input': civicLongitude.invalid && (civicLongitude.dirty || civicLongitude.touched)}" >
                    </td>
                </tr>
                <tr>
                    <th>Contact Name</th>
                    <td>
                        <input size=70 id="contactName" name="contactName" type='text' class="form-control w-100"
                            [(ngModel)]="tmpBuilding.contactName" #contactName="ngModel"
                            [ngClass]="{ 'invalid-input': contactName.invalid && (contactName.dirty || contactName.touched)}" >
                    </td>
                </tr>
                <tr>
                    <th>Contact Number</th>
                    <td>
                        <input size=70 id="contactNumber" name="contactNumber" type='text' class="form-control w-100"
                            [(ngModel)]="tmpBuilding.contactNumber" #contactNumber="ngModel"
                            [ngClass]="{ 'invalid-input': contactNumber.invalid && (contactNumber.dirty || contactNumber.touched)}" >
                    </td>
                </tr>
                <tr>
                    <th>Contact Email</th>
                    <td>
                        <input size=70 id="contactEmail" name="contactEmail" type='text' class="form-control w-100"
                            [(ngModel)]="tmpBuilding.contactEmail" #contactEmail="ngModel"
                            [ngClass]="{ 'invalid-input': contactEmail.invalid && (contactEmail.dirty || contactEmail.touched)}" >
                    </td>
                </tr>
                <tr>
                    <th>Construction</th>
                    <td>
                        <input size=70 id="construction" name="construction" type='text' class="form-control w-100"
                            [(ngModel)]="tmpBuilding.construction" #construction="ngModel"
                            [ngClass]="{ 'invalid-input': construction.invalid && (construction.dirty || construction.touched)}" >
                    </td>
                </tr>
                <tr>
                    <th>Deleted</th>
                    <td>
                        <input id="deleted" name="deleted" type='checkbox' class="form-control move-left"
                            [(ngModel)]="tmpBuilding.deleted" #deleted="ngModel"
                            [ngClass]="{ 'invalid-input': deleted.invalid && (deleted.dirty || deleted.touched)}" >
                    </td>
                </tr>
            </tbody>
        </table>
        <div *ngIf="errorMsg" class="alert alert-danger">{{errorMsg}}</div>
    </form>
</div>

<div class="modal-footer">
    <button  (click)="onSave()" class="btn btn-primary">Save</button>
    <button (click)="onCancel()" class="btn btn-secondary">Cancel</button>
</div>
